import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function Comp() {
    const { useLang } = useGlobal();
    const { t } = useLang('smarthomepanel');

    return (
        <div className={`${css.gsapB} gsapB2`}>
            <div className="msg-box msg-trigger1">
                <div className="msg-line1">{t('smart_home_panel.eight_title')}</div>
                <div className="msg-line2 msg-color2">{t('smart_home_panel.eight_subtitle_other')}</div>
                <div className="msg-line3">{t('smart_home_panel.eight_subtitle_white')}</div>
            </div>
            <div className="img-box">
                <div className="video-trigger">
                    <EFVideo sources={['/video/smarthomepanel/video2.webm', '/video/smarthomepanel/video2.mp4']} className="video" loop />
                </div>
                <div className="video-tips msg-trigger2">
                    {t('smart_home_panel.eight_des_white')}
                    <span
                        className="video-color2"
                        dangerouslySetInnerHTML={{
                            __html: t('smart_home_panel.eight_des_gray'),
                        }}
                    ></span>
                    {t('smart_home_panel.eight_des2_white')}
                    <span className="video-color2"> {t('smart_home_panel.eight_des2_gray')}</span>
                </div>
            </div>
        </div>
    );
}
